import React from 'react';
import cloneDeep from 'lodash/cloneDeep';

import EditableTextView from '../../../../../../components/EditableTextView';

const editorOptions = {
  // paste: {
  //   forcePlainText: false,
  //   cleanPastedHTML: false
  // },
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' },
      'unorderedlist',
      'orderedlist'
    ]
  }
};

const onParagraphChange = (itemId, dispatch) => (html) => {
  dispatch('UPDATE_ITEM_DATA', {
    _id: itemId,
    paragraph: html
  });
};

function renderParagraph(lesson, editable, dispatch) {
  const variant = lesson.variant;
  const firstItem = lesson.items[0];
  let updatedEditorOptions = {};
  if (variant === 'fullCImpact') {
    updatedEditorOptions = {
      paste: {
        forcePlainText: true,
        cleanPastedHTML: false
      }
    };
  }
  const clonedEditorOptions = Object.assign(cloneDeep(editorOptions), updatedEditorOptions);
  switch (variant) {
    case 'a':
    case 'b':
    case 'fullCImpact':
    case 'fullDImpact':
      return (
        <EditableTextView
          text={firstItem.paragraph}
          placeholder="Enter text here..."
          wrapperClassName="brand--body brand--linkColor"
          editable={editable}
          itemId={firstItem._id}
          onChange={onParagraphChange(firstItem._id, dispatch)}
          editorOptions={clonedEditorOptions}
        />
      );
    default:
      return null;
  }
}

function getVariantClassName(variant) {
  switch (variant) {
    case 'a':
      return 'a';
    case 'b':
      return 'b';
    case 'fullCImpact':
      return 'c';
    case 'fullDImpact':
      return 'd';
    default:
      return null;
  }
}

export default (props) => {
  const lesson = props.lesson;
  const variant = lesson.variant;
  const variantClassName = getVariantClassName(variant);
  const styles = {
    maxWidth: {},
    tempStyle: {
      fontSize: '45px',
      lineHeight: '74.97px',
      paddingTop: '0px',
      paddingLeft: '0px',
      marginLeft: '0px',
      paddingRight: '0px',
      marginRight: '0px',
      textAlign: 'start',
      position: 'absolute',
      color: '#aaa',
      zIndex: '1',
      display: 'none',
      top: 0,
      left: 0,
      right: 0,
      overflow: 'hidden'
    }
  };
  if (variant === 'fullCImpact' || variant === 'fullDImpact') {
    styles.maxWidth = {
      margin: '0 auto',
      maxWidth: '820px',
      paddingLeft: '20px',
      paddingRight: '20px'
    };
  }

  const { editable, dispatch } = props;
  return (
    <div>
      <div className={`block-impact block-impact--${variantClassName}`}>
        <div className="block-impact__wrap" style={styles.maxWidth}>
          <div>
            <div>
              <div>
                <div className="block-impact__note-background brand--background" />
                <div className="block-impact__note-icon brand--color">
                  <i className="icon icon-info" />
                </div>
                <div className="brand--linkColor block-impact__quote brand--linkColor brand--head brand--beforeBackground">
                  <div className="fr-box fr-inline">
                    <div className="fr-wrapper" dir="auto">
                      <div className="fr-element fr-view">
                        {renderParagraph(lesson, editable, dispatch)}
                      </div>
                    </div>
                    <span className="fr-placeholder" style={styles.tempStyle}>
                      Enter some text
                    </span>
                  </div>
                  <textarea style={{ display: 'none' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
